// Mirrors App.tsx's render precedence: staff dashboard > technician view >
// company dashboard > customer portal > login modal. Kept pure for testing.
export type LinkSessionState = 'anonymous' | 'customer' | 'company' | 'staff' | 'technician';
export type LinkRouteServed =
  | 'questionnaire'
  | 'customer_portal'
  | 'company_dashboard'
  | 'admin_dashboard'
  | 'technician_view'
  | 'login_modal'
  | 'landing';

export const resolveLinkEventContext = (
  currentUser: { role?: string } | null,
  currentCompany: object | null,
  currentCustomer: object | null,
  hasAppointmentParam: boolean
): { sessionState: LinkSessionState; routeServed: LinkRouteServed } => {
  if (currentUser) {
    const isTechnician = currentUser.role === 'technician';
    return {
      sessionState: isTechnician ? 'technician' : 'staff',
      routeServed: isTechnician ? 'technician_view' : 'admin_dashboard'
    };
  }
  if (currentCompany) return { sessionState: 'company', routeServed: 'company_dashboard' };
  if (currentCustomer) {
    return {
      sessionState: 'customer',
      routeServed: hasAppointmentParam ? 'questionnaire' : 'customer_portal'
    };
  }
  return { sessionState: 'anonymous', routeServed: 'login_modal' };
};
